import React, {useEffect, useState} from 'react';
import {Avatar, Button, CircularProgress, Fade, Paper, Typography} from "@mui/material";
import music from "../../../../assets/music/credits.mp3"
import SimpleDialog from "../../../widgets/dialogs/SimpleDialog";
import { useTheme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Background from "../../../../assets/Ocean-bg.jpg";
import SVG from "react-inlinesvg";
import multiavatar from "@multiavatar/multiavatar";
import axios from "axios";
import {GET_ALL_USERS_BY_CMP_URL} from "../../../../services/utils/ApiUrls";
import {getConfig} from "../../../../services/utils/ConfigUtils";
import {getAccountInfo} from "../../../../utils/GenericUtils";
import FavoriteTwoToneIcon from '@mui/icons-material/FavoriteTwoTone';

const myStyle = makeStyles(() => ({
	"@keyframes credits": {
		"0%": {
			top: "110%",
		},
		"100%": {
			top: "-500%",
		},
	},
	wrapper: {
		position: "absolute",
		top: "110%",//700
		backgroundColor: "rgba(0, 0, 0, 0)",
	},
	wrapperActive: {
		display: "block",
		animation: "$credits 200s linear",
	},
	wrapperHidden: {
		display: "none",
		animation: "none",
	},
}))

export const Credits = () => {
	const classes = myStyle();
	let theme = useTheme();
	let audio = new Audio(music)
	const [open, setOpen] = useState(true);
	const [click, setClick] = useState(false);
	const [start, setStart] = useState(false);
	const [visible, setVisible] = useState(false);
	const [grazie, setGrazieVisible] = useState(false);
	const [users, setUsers] = useState([]);
	
	const startAnimation = () => {
		setTimeout(() => {
			setStart(true)
		}, 400);
		setTimeout(() => {
			setStart(false);
		}, 114000)
		setTimeout(() => {
			setVisible(true)
		}, 114100)
		setTimeout(() => {
			setGrazieVisible(true);
		}, 124200)
		setTimeout(() => {
			setVisible(false);
		}, 280000)
	}
	
	useEffect(() => {
		axios
			.get(GET_ALL_USERS_BY_CMP_URL + getAccountInfo()?.companyId, getConfig())
			.then((response) => {
				if (response.status === 200) {
					setUsers(response.data);
				}
			})
			.catch((err) => console.error(JSON.stringify(err)))
	}, [])
	
	useEffect(() => {
		document.body.style =
			`background-image: url(${Background});
		background-attachment: fixed;
    background-size: cover;`;
	}, []);
	
	return (
		<React.Fragment>
			<SimpleDialog maxWidth={"md"} open={open} customFullScreen={false}
			              content={
				              <React.Fragment>
					              <div style={{
						              display: "flex",
						              padding: 20,
						              flexDirection: "column",
						              alignContent: "center",
						              justifyContent: "center"
					              }}>
						              <Typography variant={"h4"} align={"center"} style={{margin: 20, marginBottom: 5}}>
							              <b>Grazie per aver usato Atlantis!</b>
						              </Typography>
						              <Typography variant={"h6"} color={"textSecondary"} align={"center"}
						                          style={{margin: 20, marginBottom: 40}}>
							              Clicca su play e goditi quest ultimo momento insieme a noi
						              </Typography>
						              <Button disabled={click} onClick={() => {
							              setClick(true);
							              audio.play().then(() => {
								              startAnimation();
								              setOpen(false);
							              })
						              }} id={"play-music"} style={{
							              margin: "auto",
							              boxShadow: theme.shadows[18],
							              background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
							              color: "#FFF",
							              fontSize: 40,
							              borderRadius: 22,
							              paddingLeft: 40,
							              paddingRight: 40
						              }}>
							              {
								              click ? <CircularProgress/> : "play"
							              }
						              </Button>
					              </div>
				              </React.Fragment>
			              }/>
			
			<article style={{width: "100%", display: "flex", justifyContent: "center", flexWrap: "wrap"}}>
				<Paper elevation={0} className={`${classes.wrapper} ${start ? classes.wrapperActive : classes.wrapperHidden}`}
				>
					<Typography
						style={{lineHeight: 4, color: "#FFF", fontFamily: "Indie Flower", fontSize: "40px", fontWeight: "bold"}}
						variant={"h5"}
						align={"center"}>
						Ed eccoci quà, per un'ultima giornata assieme...<br/>
						dopo aver solcato mari inesplorati<br/>
						ed aver nuotato nelle tenebre più profonde...<br/>
						dopo aver scoperto bug e dato alla vita nuove feature<br/>
						(<i>che poi si sa... sono la stessa cosa</i>😏🙄)<br/>
						dopo aver caricato tamponi, duplicato pazienti,<br/>
						incasinato anagrafiche e sdoppiato provvedimenti...<br/>
						<br/>
						É stato bello condividere questi momenti con te mio caro operatore<br/>
						Spero di essere stato un fedele compagno per te in questi anni o mesi<br/>
						... forse non sono stato il migliore, ma almeno ci ho provato!<br/>
						<br/>
						Con questo messaggio ci tengo a ringraziarti<br/>
						per il tempo passato con te... ma le sorprese non finiscono qui...<br/>
						resta in attesa<br/>
						...
					</Typography>
				</Paper>
				{
					users?.map((user, index) => {
						return (
							<Fade key={index} in={visible} style={{transitionDelay: `${index}s`}} mountOnEnter unmountOnExit>
								<Paper id={`user-${index}`} elevation={20} style={{
									backgroundColor: "rgba(0,0,0,0.2)",
									backdropFilter: "blur(8px)",
									display: "grid",
									gridTemplateColumns: "auto 1fr",
									padding: 15,
									margin: 40,
									marginLeft: 60,
									marginRight: 60,
									borderRadius: 22,
									color: "#FFF"
								}}>
									<Avatar
										style={{marginRight: 10, width: 80, height: 80}}>
										<SVG src={multiavatar(user?.alias)}/>
									</Avatar>
									<Typography style={{margin: "auto"}}>
										<b>{user?.alias}</b>
									</Typography>
								</Paper>
							</Fade>
						)
					})
				}
				<Fade in={grazie} style={{transitionDelay: `4s`}} mountOnEnter>
					<Paper elevation={0} style={{
						position: "fixed",
						top: "20%",
						backgroundColor: "rgba(0,0,0,0)"
					}}>
						<Typography align={"center"} variant={"h1"} style={{fontFamily: "Amatic SC", color: "#FFF", fontSize: 180}}>
							<FavoriteTwoToneIcon style={{fontSize: 280, color: "#FFF"}}/><br/>
							Grazie !
						</Typography>
					</Paper>
				</Fade>
			</article>
		</React.Fragment>
	);
};
